import { render, staticRenderFns } from "./p-file-preview-popup.vue?vue&type=template&id=05a5907e"
import script from "./p-file-preview-popup.vue?vue&type=script&lang=js"
export * from "./p-file-preview-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a5907e')) {
      api.createRecord('05a5907e', component.options)
    } else {
      api.reload('05a5907e', component.options)
    }
    module.hot.accept("./p-file-preview-popup.vue?vue&type=template&id=05a5907e", function () {
      api.rerender('05a5907e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mpackages/views/popups/p-file-preview-popup/p-file-preview-popup.vue"
export default component.exports